import { lazy } from 'react';

// project import
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
// import AuthGoogleOnly from 'sections/auth/auth-forms/AuthGoogleOnly';

// render - login
// const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthGoogleOnly = Loadable(lazy(() => import('pages/auth/login')));

const AuthRegister = Loadable(lazy(() => import('pages/auth/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));
const VerifyEmail = Loadable(lazy(() => import('pages/auth/VerifyEmail')));
const AuthResetPasswordLink = Loadable(lazy(() => import('sections/auth/auth-forms/AuthResetPasswordLink')));
const CorporateSignUp = Loadable(lazy(() => import('pages/auth/corporate-sign-up')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        // {
        //   path: '/',
        //   // element: <AuthLogin />
        //   element: <AuthGoogleOnly/>
        // },
        {
          path: 'login',
          // element: <AuthLogin />
          element: <AuthGoogleOnly />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        },
        {
          path: 'verify-email',
          element: <VerifyEmail />
        },
        {
          path: '/__/auth/action',
          element: <AuthResetPasswordLink />
        },
        {
          path: '/corporate-signup',
          element: <CorporateSignUp />
        }
      ]
    }
  ]
};

export default LoginRoutes;
